module.exports = __webpack_public_path__ + "static/media/Monitor.b275fa3f.svg";